export const MODAL_CONTAINER_WIDTH_CLASSES = [
  "tw:min-w-[600px]!",
  "tw:max-w-[50vw]!",
];
